import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { LIST_ITEM_HEIGHT } from '@/experiences/sales-portal/components/address-search-input/constants';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface AddressSearchEmptyStateProps {}

const AddressSearchEmptyState: React.FC<
  AddressSearchEmptyStateProps
> = ({}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.emptyStateContainer}>
      <Typography variant="paragraph-sm">
        {i18n.t('sales_portal.edit_account.address_search.no_results')}
      </Typography>
    </View>
  );
};

export default AddressSearchEmptyState;

const useStyles = createStyles((theme) => ({
  emptyStateContainer: {
    alignItems: 'center',
    height: LIST_ITEM_HEIGHT,
    justifyContent: 'center',
    padding: theme.sk.spacing.spaceMedium,
  },
}));
